module.exports = __webpack_public_path__ + "static/media/arrow-down-black.f50942ed.svg";